import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=25ef8ecc&scoped=true&"
import script from "./Logo.vue?vue&type=script&lang=js&"
export * from "./Logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ef8ecc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.clcp.cliquedomains.com/web/app/themes/clc-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25ef8ecc')) {
      api.createRecord('25ef8ecc', component.options)
    } else {
      api.reload('25ef8ecc', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=25ef8ecc&scoped=true&", function () {
      api.rerender('25ef8ecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/vue/Components/Navigation/Logo.vue"
export default component.exports